"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.persistor = exports.store = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const redux_1 = require("redux");
const redux_persist_1 = require("redux-persist");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const authSlice_1 = __importDefault(require("./features/auth/authSlice"));
const communicationSlice_1 = __importDefault(require("./components/communicationBox/communicationSlice"));
const actionsSlice_1 = __importDefault(require("./features/actions/actionsSlice"));
const middleware_1 = require("./utils/middleware");
const profileSlice_1 = __importDefault(require("./features/profile/profileSlice"));
const scheduleSlice_1 = __importDefault(require("./features/schedules/scheduleSlice"));
const commonSlice_1 = __importDefault(require("./features/common/commonSlice"));
const SchedulesSlice_1 = __importDefault(require("./features/schedules/SchedulesSlice"));
const officersSlice_1 = __importDefault(require("./features/officer/officersSlice"));
const qualityAssuranceSlice_1 = __importDefault(require("./features/qualityAssurance/qualityAssuranceSlice"));
const callSlice_1 = __importDefault(require("./features/call/callSlice"));
const middlewareUtils_1 = require("./utils/middlewareUtils");
const ticketSlice_1 = __importDefault(require("./features/ticket/ticketSlice"));
const campaignSlice_1 = __importDefault(require("./features/campaign/campaignSlice"));
const supportSlice_1 = __importDefault(require("./features/support/supportSlice"));
const eventSlice_1 = __importDefault(require("./components/event/eventSlice"));
const notificationSlice_1 = __importDefault(require("./features/notifications/notificationSlice"));
const reducers = redux_1.combineReducers({
    auth: authSlice_1.default,
    common: commonSlice_1.default,
    communication: communicationSlice_1.default,
    event: eventSlice_1.default,
    actions: actionsSlice_1.default,
    profile: profileSlice_1.default,
    schedule: scheduleSlice_1.default,
    schedules: SchedulesSlice_1.default,
    officers: officersSlice_1.default,
    qualityAssurance: qualityAssuranceSlice_1.default,
    call: callSlice_1.default,
    campaign: campaignSlice_1.default,
    ticket: ticketSlice_1.default,
    support: supportSlice_1.default,
    notifications: notificationSlice_1.default,
});
const persistConfig = {
    key: 'root',
    storage: async_storage_1.default,
    whitelist: ['auth', 'notifications', 'qualityAssurance'],
};
const persistedReducer = redux_persist_1.persistReducer(persistConfig, reducers);
exports.store = toolkit_1.configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }).concat(middleware_1.setAnalyticsUser, middleware_1.logger, middlewareUtils_1.handle401Error),
});
exports.persistor = redux_persist_1.persistStore(exports.store);
